import { CancelToken } from 'axios';
import { useMutation } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { VIDEO_INTEGRATION_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { routeReplacer } from '~/Helpers/String.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import {
  IVODUpdateIntegrationParams,
  IVODUpdateIntegrationResponse,
} from '~/Models/DTO/VideoOnDemand.models';

interface IUseRequestUpdateIntegrationVODOptions {
  cancellationToken?: CancelToken;
  onSuccess?: () => void;
}

export const useRequestUpdateIntegrationVOD = (
  options: IUseRequestUpdateIntegrationVODOptions = {},
) => {
  const { onSuccess, cancellationToken } = options;

  const {
    data: vodIntegrationResponse,
    error: vodUpdateIntegrationError,
    isLoading: isVodIntegrationUpdateLoading,
    mutate: updateIntegrationVod,
    isSuccess: isVodIntegrationUpdateSuccess,
  } = useMutation<IVODUpdateIntegrationResponse, IErrorResponse, IVODUpdateIntegrationParams>(
    async (params: IVODUpdateIntegrationParams) =>
      requestReactQuery<IVODUpdateIntegrationResponse>({
        url: routeReplacer(VIDEO_INTEGRATION_SERVICE_URLS.VOD_PATCH_INTEGRATION, {
          integrationId: params.integrationId,
        }),
        data: {
          disabled: params.disabled,
          tcAcceptedDate: params.tcAcceptedDate,
          homeSportsClub: params.homeSportsClub,
        },
        config: { method: 'PATCH', cancelToken: cancellationToken },
      }),
    {
      mutationKey: REQUEST_ACTIONS.UPLOAD_VOD_VIDEO,
      onSuccess,
    },
  );

  return {
    vodIntegrationError: vodUpdateIntegrationError as IErrorResponse,
    vodIntegrationResponse,
    updateIntegrationVod,
    isVodIntegrationUpdateLoading,
    isVodIntegrationUpdateSuccess,
  };
};
